import CreateBookingV3Modules from "../../create-booking-v3";

export default [...CreateBookingV3Modules];
